import { render, staticRenderFns } from "./DeskTableItem.vue?vue&type=template&id=1c45dd3b&scoped=true"
import script from "./DeskTableItem.vue?vue&type=script&lang=js"
export * from "./DeskTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45dd3b",
  null
  
)

export default component.exports